import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";

// Your Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyAOY4tjb0XLBxD4N1_dpjjZaMAo1N5HFxw",
  authDomain: "thegolden-20ee3.firebaseapp.com",
  projectId: "thegolden-20ee3",
  storageBucket: "thegolden-20ee3.firebasestorage.app",
  messagingSenderId: "643730075250",
  appId: "1:643730075250:web:8bcefc38c5dedfd9d25ceb"
};
// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Export Firebase services
export const auth = getAuth(app);
export const db = getFirestore(app); // Firestore
export const storage = getStorage(app); // Storage
export default app;
